(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-ambassador-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.nordal-amb-detail').forEach(function (root) {
      var track = root.querySelector('[data-ambd-track]');
      if (!track) { return; }
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-ambd-slide]'));
      if (slides.length < 1) { return; }
      var prev = root.querySelector('[data-ambd-prev]');
      var next = root.querySelector('[data-ambd-next]');
      var count = root.querySelector('[data-ambd-count]');
      var index = parseInt(root.getAttribute('data-start-index'), 10) || 0;
      var ambientImg = root.querySelector('.ambd-ambient__img');

      function render() {
        if (count) { count.textContent = (index + 1) + '/' + slides.length; }
        if (prev) { prev.disabled = index === 0; }
        if (next) { next.disabled = index === slides.length - 1; }
        var url = slides[index].getAttribute('data-url');
        var name = slides[index].getAttribute('data-name');
        // Swap the ambient backdrop to match whichever ambassador is now in view.
        var imgSrc = slides[index].getAttribute('data-img');
        if (ambientImg && imgSrc && ambientImg.getAttribute('src') !== imgSrc) {
          // The tag ships with a srcset, which browsers prefer over a plain src
          // change — drop it so the swap actually takes effect.
          ambientImg.removeAttribute('srcset');
          ambientImg.src = imgSrc;
        }
        // Keep the address bar in step, so sharing or reloading lands on this ambassador.
        if (url && window.history && history.replaceState) {
          history.replaceState(null, '', url);
          if (name) { document.title = name; }
        }
      }

      function go(i, smooth) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        var behavior = smooth === false ? 'auto' : 'smooth';
        track.scrollTo({ left: index * track.clientWidth, behavior: behavior });
        render();
      }

      // Jump to the opened ambassador without animating past the others.
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = index * track.clientWidth;
      track.style.scrollBehavior = prevBehavior;
      render();

      if (prev) { prev.addEventListener('click', function () { go(index - 1); }); }
      if (next) { next.addEventListener('click', function () { go(index + 1); }); }

      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (i !== index) { index = i; render(); }
        }, 90);
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });

      window.addEventListener('resize', function () { go(index, false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-ambassador-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAmbGrid(root) {
      if (!root || root.dataset.ambInit === '1') return;
      root.dataset.ambInit = '1';

      /* Gedelegeerd, niet per knop: de marquee hieronder kloont kaarten bij, en die
         klonen hebben anders geen werkende pop-up. */
      root.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-amb-trigger]') : null;
        if (!btn) return;
        var dialog = document.getElementById(btn.getAttribute('data-amb-target'));
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });

      var dialogs = root.querySelectorAll('[data-amb-modal]');
      dialogs.forEach(function (dialog) {
        var closeBtn = dialog.querySelector('[data-amb-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
      });

      initAmbMarquee(root);
    }

    /* De rij liep als CSS-marquee binnen een `overflow: hidden` viewport, dus vegen
       (en trackpad-scrollen) deed niets. Hier nemen we de beweging over via
       scrollLeft op een echt scrollbare viewport: hij loopt nog steeds vanzelf
       door, maar je kunt er nu doorheen swipen en hij pakt het daarna weer op. */
    function initAmbMarquee(root) {
      var viewport = root.querySelector('.ambg-viewport');
      var track = root.querySelector('.ambg-track');
      if (!viewport || !track) return;

      var seqs = Array.prototype.slice.call(track.querySelectorAll('.ambg-seq'));
      if (seqs.length < 2) return;

      root.classList.add('is-swipe');

      var HOLD_MS = 4000;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var speed = parseFloat(getComputedStyle(track).getPropertyValue('--amb-speed')) || 36;
      if (!speed || speed < 4) speed = 36;

      var loopWidth = 0;
      var rafId = null;
      var lastTs = 0;
      var pos = 0;
      var hovering = false;
      var holdUntil = 0;
      var inView = false;

      /* Drie sets in plaats van twee: de rail wordt in de middelste gezet, zodat er
         in beide richtingen een volledige set marge staat. Zonder die extra set kun
         je vanaf het begin niet terugvegen (scrollLeft kan niet onder 0) en loop je
         bij een snelle veeg vooruit tegen het fysieke einde aan. */
      function ensureSets() {
        var guard = 0;
        while (track.querySelectorAll('.ambg-seq').length < 3 && guard < 6) {
          track.appendChild(seqs[1].cloneNode(true));
          guard++;
        }
        /* Op extreem brede schermen past één set niet over de viewport heen; plak er
           dan nog sets bij tot de sprong terug nooit een gat laat vallen. */
        guard = 0;
        while (seqs[0].offsetWidth > 0
          && track.scrollWidth < 2 * seqs[0].offsetWidth + viewport.clientWidth
          && guard < 6) {
          track.appendChild(seqs[1].cloneNode(true));
          guard++;
        }
      }

      function measure() {
        ensureSets();
        loopWidth = seqs[1].offsetLeft - seqs[0].offsetLeft;
      }

      function wrapRel(v) {
        if (loopWidth <= 0) return v;
        while (v >= loopWidth) v -= loopWidth;
        while (v < 0) v += loopWidth;
        return v;
      }

      /* Onopvallend terug naar de middelste set zodra de rail daarbuiten komt: op dat
         punt staat exact hetzelfde beeld, dus de sprong is onzichtbaar. */
      function reseat() {
        if (loopWidth <= 0) return;
        var rel = viewport.scrollLeft;
        /* `rel < 1` en niet `rel < 0`: scrollLeft kan niet negatief worden, dus de
           linkerrand zelf is het punt waarop we moeten terugzetten - anders loop je
           bij terugvegen vast tegen het begin van de rail. */
        if (rel < 1 || rel >= 2 * loopWidth) {
          viewport.scrollLeft = loopWidth + wrapRel(rel);
          pos = viewport.scrollLeft;
        }
      }

      function seat() {
        if (loopWidth <= 0) return;
        viewport.scrollLeft = loopWidth;
        pos = viewport.scrollLeft;
      }

      function frame(ts) {
        rafId = requestAnimationFrame(frame);
        var dt = lastTs ? Math.min(100, ts - lastTs) : 0;
        lastTs = ts;

        /* Re-sync na een veeg of trackpad-scroll die de rail onder ons verschoof.
           Bewust zonder scrollLeft te zetten: dat zou de momentum-scroll van de
           bezoeker meteen weer afkappen. */
        if (Math.abs(viewport.scrollLeft - pos) > 1.5) pos = viewport.scrollLeft;
        if (!dt || loopWidth <= 0) return;
        if (reduceMotion || hovering || document.hidden || Date.now() < holdUntil) return;

        pos += loopWidth / speed * dt / 1000;
        viewport.scrollLeft = pos;
        if (pos >= 2 * loopWidth) reseat();
      }

      function play() {
        if (rafId) return;
        measure();
        if (viewport.scrollLeft <= 0) seat();
        lastTs = 0;
        pos = viewport.scrollLeft;
        rafId = requestAnimationFrame(frame);
      }
      function stop() { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }
      function hold() { holdUntil = Date.now() + HOLD_MS; }

      root.addEventListener('mouseenter', function () { hovering = true; });
      root.addEventListener('mouseleave', function () { hovering = false; });
      viewport.addEventListener('focusin', hold);
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
        viewport.addEventListener(evt, hold, { passive: true });
      });
      viewport.addEventListener('scroll', reseat, { passive: true });
      window.addEventListener('resize', function () { measure(); reseat(); });

      measure();
      seat();

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.intersectionRatio > 0;
            if (inView) play(); else stop();
          });
        }, { threshold: [0, 0.01] });
        io.observe(root);
      } else {
        inView = true;
        play();
      }

      /* Bewust GEEN wheel-handler die verticale scroll onderschept en met
         window.scrollBy doorzet: dat vervangt de native momentum-scroll door een
         kale pixel-voor-pixel sprong, en dan kruipt de pagina zodra je met de
         cursor over de rij staat. De rail is verticaal niet scrollbaar
         (overflow-y: hidden) en touch-action: pan-x laat verticaal vegen door,
         dus verticale scroll gaat vanzelf naar de pagina. */
    }

    document.querySelectorAll('.nordal-amb-grid').forEach(initAmbGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-ambassador-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Skip the >1MB background video on data-saver or 2g connections; the
    // poster image already covers the slide, so nothing visual is lost.
    var conn = navigator.connection || navigator.webkitConnection || {};
    var allowVideo = !conn.saveData && conn.effectiveType !== 'slow-2g' && conn.effectiveType !== '2g';

    // Attach the deferred <source data-src> only when we actually want to play,
    // so the video's bytes never compete with the LCP poster during page load.
    function attachSource(video) {
      var src = video.querySelector('source[data-src]');
      if (src && !src.getAttribute('src')) {
        src.setAttribute('src', src.getAttribute('data-src'));
        try { video.load(); } catch (e) {}
      }
    }

    function whenVisible(root, cb) {
      if (!('IntersectionObserver' in window)) { cb(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { io.disconnect(); cb(); }
        });
      }, { rootMargin: '400px 0px' });
      io.observe(root);
    }

    function initSlider(root) {
      if (root.dataset.ambInit === 'true') return;
      root.dataset.ambInit = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-amb-slide]'));
      if (slides.length <= 1) {
        whenVisible(root, function () { playActiveVideo(slides, 0); });
        return;
      }

      var prevBtn = root.querySelector('[data-amb-prev]');
      var nextBtn = root.querySelector('[data-amb-next]');
      var n = slides.length;
      var current = 0;
      var timer = null;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = parseInt(root.dataset.interval, 10);
      if (isNaN(interval) || interval < 1500) interval = 7000;
      var activated = false;

      function playActiveVideo(list, activeIndex) {
        if (!allowVideo) return;
        list.forEach(function (slide, i) {
          var video = slide.querySelector('[data-amb-video]');
          if (!video) return;
          if (i === activeIndex) {
            attachSource(video);
            try { video.currentTime = 0; var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }

      function show(index) {
        current = ((index % n) + n) % n;
        slides.forEach(function (slide, i) {
          var on = i === current;
          slide.classList.toggle('active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) { slide.removeAttribute('inert'); } else { slide.setAttribute('inert', ''); }
        });
        if (activated) playActiveVideo(slides, current);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function start() {
        stop();
        if (reduceMotion) return;
        timer = setInterval(function () { show(current + 1); }, interval);
      }

      function restart() { stop(); start(); }

      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); restart(); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      whenVisible(root, function () {
        // The clip is >1MB; the poster covers the slide visually, so hold the
        // video download/playback until the rest of the page has loaded instead
        // of competing with the LCP image on slow connections.
        var go = function () {
          activated = true;
          playActiveVideo(slides, current);
          start();
        };
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
      });
    }

    function playActiveVideo(list, activeIndex) {
      if (!allowVideo) return;
      list.forEach(function (slide, i) {
        var video = slide.querySelector('[data-amb-video]');
        if (!video) return;
        if (i === activeIndex) {
          attachSource(video);
          try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        }
      });
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-amb-slider]')).forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-amb-slider]');
      if (root) initSlider(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-ambassadors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRotator(root) {
      if (root.dataset.ambInit === '1') return;
      root.dataset.ambInit = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-amb-slide]'));
      if (!slides.length) return;
      var bgLayers = Array.prototype.slice.call(root.querySelectorAll('[data-amb-bg]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-amb-dot]'));
      // Twee sets pijlen in de DOM (desktop onderaan, mobiel bovenin het tekstblok),
      // dus alle knoppen aansluiten in plaats van alleen de eerste.
      var prev = Array.prototype.slice.call(root.querySelectorAll('[data-amb-prev]'));
      var next = Array.prototype.slice.call(root.querySelectorAll('[data-amb-next]'));
      var n = slides.length;
      var idx = 0;
      var timer = null;
      var paused = false;

      var autoplay = root.dataset.ambAutoplay !== 'false';
      var interval = parseInt(root.dataset.ambInterval, 10) || 4000;

      // No poster/video bytes until the section has actually been scrolled
      // into view - show(0) runs at init, long before the user gets here.
      var seen = false;

      function playVideo(slide) {
        if (!seen) return;
        var v = slide.querySelector('[data-amb-video]');
        if (!v) return;
        if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
        if (!v.dataset.loaded) { v.dataset.loaded = '1'; try { v.load(); } catch (e) {} }
        try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
      function pauseVideo(slide) {
        var v = slide.querySelector('[data-amb-video]');
        if (v) { try { v.pause(); } catch (e) {} }
      }

      function show(k) {
        idx = ((k % n) + n) % n;
        slides.forEach(function (sl, i) {
          var on = i === idx;
          sl.classList.toggle('active', on);
          if (on) { sl.removeAttribute('aria-hidden'); playVideo(sl); }
          else { sl.setAttribute('aria-hidden', 'true'); pauseVideo(sl); }
        });
        dots.forEach(function (d, i) {
          var on = i === idx;
          d.classList.toggle('active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        bgLayers.forEach(function (bg) {
          bg.classList.toggle('active', parseInt(bg.dataset.index, 10) === idx);
        });
      }

      function startAuto() {
        // Ook bij 'beweging beperken' doorlopen: een wissel is een harde swap (de
        // achtergrondfade valt dan weg via CSS), en pijlen/bolletjes blijven de pauzeknop.
        if (!autoplay || n < 2) return;
        stopAuto();
        timer = setInterval(function () { if (!paused) show(idx + 1); }, interval);
      }
      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.index, 10) || 0); startAuto(); });
      });
      prev.forEach(function (btn) {
        btn.addEventListener('click', function () { show(idx - 1); startAuto(); });
      });
      next.forEach(function (btn) {
        btn.addEventListener('click', function () { show(idx + 1); startAuto(); });
      });

      // Alleen pauzeren boven de bediening. De sectie is op een laptop bijna
      // schermvullend, dus pauzeren op de hele sectie zette de rotatie vaak stil.
      root.querySelectorAll('.amb-slider-ctrl, .amb-arrows--inline').forEach(function (el) {
        el.addEventListener('mouseenter', function () { paused = true; });
        el.addEventListener('mouseleave', function () { paused = false; });
      });

      show(0);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { seen = true; startAuto(); playVideo(slides[idx]); }
            else { stopAuto(); pauseVideo(slides[idx]); }
          });
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        seen = true;
        startAuto();
        playVideo(slides[idx]);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-amb-rotator]').forEach(initRotator);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-amb-rotator]');
      if (root) initRotator(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(text, fallback) {
      var base = (text || '').toLowerCase()
        .replace(/[^a-z0-9À-ɏ\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      return base || fallback;
    }

    function initToc(root) {
      var aside = root.querySelector('[data-article-toc]');
      var content = root.querySelector('[data-article-content]');
      if (!aside || !content) return;
      if (aside.dataset.tocInit === '1') return;
      aside.dataset.tocInit = '1';

      var linksWrap = aside.querySelector('[data-article-toc-links]');
      var headings = content.querySelectorAll('h2');
      // Onder de 3 koppen voegt een sidebar weinig toe en oogt hij vooral leeg.
      if (!linksWrap || headings.length < 3) return;

      var anchors = [];
      headings.forEach(function (h, i) {
        if (!h.id) h.id = slugify(h.textContent, 'sectie-' + (i + 1));
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + h.id);
        });
        linksWrap.appendChild(a);
        anchors.push({ link: a, heading: h });
      });

      aside.hidden = false;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            anchors.forEach(function (item) {
              item.link.classList.toggle('is-current', item.heading === entry.target);
            });
          });
        }, { rootMargin: '-96px 0px -65% 0px', threshold: 0 });
        anchors.forEach(function (item) { observer.observe(item.heading); });
      }
    }

    function run() {
      document.querySelectorAll('.nordal-article').forEach(initToc);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.nordal-article');
      if (el) initToc(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAcc(acc) {
      if (acc.dataset.baccInit === 'true') return;
      acc.dataset.baccInit = 'true';
      var items = Array.prototype.slice.call(acc.querySelectorAll('[data-bacc-item]'));
      if (!items.length) return;
      function activate(el) {
        items.forEach(function (it) { it.classList.toggle('active', it === el); });
      }
      items.forEach(function (it) {
        it.addEventListener('mouseenter', function () { activate(it); });
        it.addEventListener('focus', function () { activate(it); });
        it.addEventListener('click', function () { activate(it); });
      });
    }
    function boot() { document.querySelectorAll('[data-bacc]').forEach(initAcc); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-bacc]');
      if (el) initAcc(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript.closest('[data-section-id]');
    function init(scope) {
      if (!scope || scope.dataset.cartBound) return;
      scope.dataset.cartBound = '1';
      scope.querySelectorAll('[data-line-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          var index = input.getAttribute('data-line-index');
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) { qty = 0; }
          if (!index) {
            var form = input.closest('form');
            if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
            return;
          }
          var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root_url + 'cart/change?line=' + index + '&quantity=' + qty;
        });
      });
      /* At quantity 1 the "−" link points to quantity=0; clicking it (especially twice
         quickly) removes the line and a queued navigation then targets the now-removed
         line → Shopify "line parameter is invalid". Disable the floored "−" so removal
         happens only via the explicit remove (×) button. */
      scope.querySelectorAll('.cartline-qty-btn[data-min]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); });
      });
    }
    if (root) init(root);
    document.addEventListener('shopify:section:load', function (e) {
      var node = e.target.querySelector('[data-section-id]') || e.target;
      if (node && node.matches('[data-section-id]')) init(node);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.colInit === '1') return;
      root.dataset.colInit = '1';

      var grid = root.querySelector('[data-collection-grid]');
      var cells = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-cell]')) : [];
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.filter-tab'));
      var sortSel = root.querySelector('[data-nordal-sort]');
      var seoGroups = Array.prototype.slice.call(root.querySelectorAll('[data-seo-group]'));
      var statusEl = root.querySelector('[data-collection-status]');

      function revealGrid() {
        if (!grid) return;
        var visible = Array.prototype.slice.call(grid.querySelectorAll('[data-cell]')).filter(function (c) { return !c.hidden; });
        visible.forEach(function (cell, i) {
          var rev = cell.querySelector('.reveal') || cell;
          rev.style.transitionDelay = ((i % 4) * 70) + 'ms';
          rev.classList.add('in');
        });
      }

      function showSeo(key) {
        if (!seoGroups.length) return;
        seoGroups.forEach(function (g) {
          var active = g.getAttribute('data-seo-group') === key;
          g.hidden = !active;
          if (active) g.classList.add('in');
        });
      }

      function applyFilter(filterKey, mode, match, label) {
        var shown = 0;
        cells.forEach(function (cell) {
          var show;
          if (mode === 'bestseller') {
            show = cell.getAttribute('data-bestseller') === 'true';
          } else if (mode === 'category') {
            var ctags = ' ' + (cell.getAttribute('data-tags') || '') + ' ';
            show = cell.getAttribute('data-cat') === match || ctags.indexOf(' ' + match + ' ') !== -1;
          } else {
            show = true;
          }
          cell.hidden = !show;
          if (show) shown++;
        });
        showSeo(filterKey);
        revealGrid();
        if (statusEl && label) {
          var tpl = statusEl.getAttribute(shown === 1 ? 'data-i18n-one' : 'data-i18n-other') || '';
          statusEl.textContent = tpl.replace('[label]', function () { return label; }).replace('[count]', shown);
        }
      }

      function applySort(mode) {
        if (!grid) return;
        var sorted = cells.slice();
        sorted.sort(function (a, b) {
          if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
          if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
          if (mode === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '', document.documentElement.lang || 'nl');
          var ab = a.dataset.bestseller === 'true' ? 1 : 0;
          var bb = b.dataset.bestseller === 'true' ? 1 : 0;
          if (ab !== bb) return bb - ab;
          return (+a.dataset.index) - (+b.dataset.index);
        });
        sorted.forEach(function (c) { grid.appendChild(c); });
      }

      Array.prototype.slice.call(root.querySelectorAll('[data-seo-inner]')).forEach(function (inner) {
        var firstPara = inner.querySelector('p');
        if (firstPara) {
          var lh = parseFloat(getComputedStyle(firstPara).lineHeight) || 27;
          var h = firstPara.offsetTop + Math.min(firstPara.offsetHeight, Math.round(lh * 6));
          if (h > 0) inner.style.setProperty('--seo-clamp', (h + 8) + 'px');
        }
      });

      Array.prototype.slice.call(root.querySelectorAll('[data-seo-expand]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var inner = btn.previousElementSibling;
          if (inner && inner.dataset.seoInner !== undefined) {
            inner.classList.remove('is-collapsed');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-pressed', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-pressed', 'true');
          applyFilter(tab.getAttribute('data-filter'), tab.getAttribute('data-mode'), tab.getAttribute('data-match'), tab.getAttribute('data-label'));
          try {
            var u = new URL(window.location.href);
            var f = tab.getAttribute('data-filter');
            if (f === 'all') { u.searchParams.delete('cat'); } else { u.searchParams.set('cat', f); }
            window.history.replaceState(null, '', u.toString());
          } catch (e) {}
        });
      });

      if (sortSel) {
        sortSel.addEventListener('change', function () {
          applySort(sortSel.value);
          revealGrid();
        });
      }

      var initFilter = null;
      try {
        var cat = new URLSearchParams(window.location.search).get('cat');
        if (cat) {
          cat = cat.toLowerCase();
          if (cat === 'musclegel') cat = 'muscle-gel';
          if (cat === 'bodycare') cat = 'body-care';
          initFilter = cat;
        }
      } catch (e) {}

      var matched = null;
      if (initFilter) {
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].getAttribute('data-filter') === initFilter) { matched = tabs[i]; break; }
        }
      }
      if (matched) { matched.click(); } else { revealGrid(); }
      if (sortSel) applySort(sortSel.value);
      revealGrid();
    }

    function boot() {
      document.querySelectorAll('.nordal-collection').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var node = e.target.querySelector ? e.target.querySelector('.nordal-collection') : null;
      if (!node && e.target.classList && e.target.classList.contains('nordal-collection')) node = e.target;
      if (node) { node.dataset.colInit = ''; init(node); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCrossSell(root) {
      if (!root || root.dataset.recLoaded === '1') {
        return;
      }
      var url = root.dataset.recUrl;
      var productId = root.dataset.productId;
      var sectionId = root.dataset.sectionId;
      var limit = root.dataset.recLimit || '3';
      if (!url || !productId || !sectionId) {
        return;
      }
      root.dataset.recLoaded = '1';
      var endpoint =
        url +
        '?section_id=' +
        encodeURIComponent(sectionId) +
        '&product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        encodeURIComponent(limit) +
        '&intent=related';
      fetch(endpoint)
        .then(function (res) {
          if (!res.ok) {
            throw new Error('rec fetch failed');
          }
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('.nordal-cross-sell .nordal-cross-sell__grid');
          var current = root.querySelector('.nordal-cross-sell__grid');
          if (!fresh || !fresh.children.length) {
            return;
          }
          fresh.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
          if (current) {
            current.replaceWith(fresh);
          } else {
            var wrap = root.querySelector('.wrap');
            if (wrap) {
              wrap.appendChild(fresh);
            }
          }
          /* The injected cards were server-rendered but never passed through the
             product-card JS (its boot runs on DOMContentLoaded / shopify:section:load),
             so the size pills (100ML/250ML) had no click handlers. Re-init ONLY the
             fresh cards via the exposed initializer - NOT a shopify:section:load
             dispatch, which THIS section also listens to and would re-fetch in a loop. */
          if (window.nordalInitProductCards) {
            window.nordalInitProductCards(fresh);
          }
        })
        .catch(function () {});
    }

    function boot() {
      document.querySelectorAll('.nordal-cross-sell[data-rec-url]').forEach(initCrossSell);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) {
        var el = e.target.querySelector('.nordal-cross-sell[data-rec-url]');
        if (el) {
          el.dataset.recLoaded = '';
          initCrossSell(el);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.nordal-header').forEach(function (head) {
      var solidOnScroll = head.getAttribute('data-solid-on-scroll') === 'true';
      var isOverlay = head.getAttribute('data-overlay') === 'true';
      // Pressing MENU on the transparent bar reveals the normal nav instead of the
      // drawer (desktop only). The latch holds that state while the page is still at
      // the top; the first real scroll hands control back to the scroll rule.
      var navLatch = false;
      var desktop = window.matchMedia('(min-width: 860px)');

      if (solidOnScroll || isOverlay) {
        var onScroll = function () {
          var scrolled = window.scrollY > 40;
          if (scrolled) { navLatch = false; }
          if (solidOnScroll) { head.classList.toggle('solid', scrolled || navLatch); }
          if (isOverlay) { head.classList.toggle('at-top', !scrolled && !navLatch); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      var burger = head.querySelector('[data-menu-toggle]');
      var menu = head.querySelector('[data-mobile-menu]');
      var iconOpen = head.querySelector('[data-icon-open]');
      var iconClose = head.querySelector('[data-icon-close]');

      var menuClose = head.querySelector('[data-menu-close]');

      function setMenu(open) {
        if (!menu) { return; }
        menu.hidden = !open;
        head.classList.toggle('menu-open', open);
        document.documentElement.classList.toggle('nordal-menu-lock', open);
        if (burger) { burger.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        if (iconOpen) { iconOpen.hidden = open; }
        if (iconClose) { iconClose.hidden = !open; }
      }

      if (burger && menu) {
        burger.addEventListener('click', function () {
          if (isOverlay && desktop.matches && head.classList.contains('at-top')) {
            navLatch = true;
            head.classList.remove('at-top');
            head.classList.add('solid');
            // The button itself is hidden once the bar turns solid, so keyboard focus
            // has to move somewhere real.
            var firstLink = head.querySelector('.head-nav a, .head-nav button');
            if (firstLink) { firstLink.focus(); }
            return;
          }
          setMenu(menu.hidden);
        });
        if (menuClose) { menuClose.addEventListener('click', function () { setMenu(false); }); }
        head.querySelectorAll('[data-menu-link]').forEach(function (a) {
          a.addEventListener('click', function () { setMenu(false); });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !menu.hidden) { setMenu(false); burger.focus(); }
        });
      }

      head.querySelectorAll('[data-mobile-group]').forEach(function (group) {
        var toggle = group.querySelector('[data-mobile-group-toggle]');
        var submenu = group.querySelector('[data-mobile-submenu]');
        if (!toggle || !submenu) { return; }
        toggle.addEventListener('click', function () {
          var open = submenu.hidden;
          submenu.hidden = !open;
          group.setAttribute('data-open', open ? 'true' : 'false');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      head.querySelectorAll('[data-has-dropdown]').forEach(function (wrap) {
        var trigger = wrap.querySelector('[data-dropdown-trigger]');
        if (!trigger) { return; }
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            wrap.removeAttribute('data-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
        wrap.addEventListener('focusin', function () {
          trigger.setAttribute('aria-expanded', 'true');
        });
        wrap.addEventListener('focusout', function (e) {
          if (!wrap.contains(e.relatedTarget)) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      });

      var searchModal = head.querySelector('[data-search-modal]');
      if (searchModal) {
        var sOpeners = head.querySelectorAll('[data-search-open]');
        var sOpen = sOpeners[0];
        var sInput = searchModal.querySelector('[data-search-input]');
        var sResults = searchModal.querySelector('[data-search-results]');
        var sDefault = searchModal.querySelector('[data-search-default]');
        var sForm = searchModal.querySelector('[data-search-form]');
        var sUrl = searchModal.getAttribute('data-search-url') || '/search/suggest';
        var sTimer = null;

        var openSearch = function () {
          searchModal.classList.add('is-open');
          searchModal.setAttribute('aria-hidden', 'false');
          setTimeout(function () { if (sInput) { sInput.focus(); } }, 60);
        };
        var closeSearch = function () {
          searchModal.classList.remove('is-open');
          searchModal.setAttribute('aria-hidden', 'true');
          if (sOpen) { sOpen.focus(); }
        };
        sOpeners.forEach(function (btn) { btn.addEventListener('click', openSearch); });
        searchModal.querySelectorAll('[data-search-close]').forEach(function (b) {
          b.addEventListener('click', closeSearch);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && searchModal.classList.contains('is-open')) { closeSearch(); }
        });

        var sEsc = function (t) {
          return (t == null ? '' : String(t)).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        };
        /* Predictive search geeft de prijs als decimale string in de presentment-valuta
           ("29.95"); die gaat door het money_format van de winkel, dat Liquid al voor
           de actieve valuta rendert (EUR, GBP, USD). */
        var sMoneyFormat = searchModal.getAttribute('data-money-format') || '€{' + '{amount_with_comma_separator}}';
        var sFormatCents = function (cents, format) {
          var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
          if (!match) { return format; }
          var group = function (n, decimals, thousands, decimal) {
            var parts = (n / 100).toFixed(decimals).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
          };
          var value;
          switch (match[1]) {
            case 'amount_no_decimals': value = group(cents, 0, ',', '.'); break;
            case 'amount_with_comma_separator': value = group(cents, 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': value = group(cents, 0, '.', ','); break;
            case 'amount_with_apostrophe_separator': value = group(cents, 2, "'", '.'); break;
            case 'amount_with_space_separator': value = group(cents, 2, ' ', ','); break;
            default: value = group(cents, 2, ',', '.');
          }
          return format.replace(match[0], value);
        };
        var sMoney = function (v) {
          if (v == null || v === '') { return ''; }
          v = String(v);
          if (/^\d+(\.\d+)?$/.test(v)) { return sFormatCents(Math.round(parseFloat(v) * 100), sMoneyFormat); }
          return v;
        };
        var renderResults = function (products, q) {
          if (!sResults) { return; }
          if (!products.length) {
            sResults.innerHTML = '<p class="nordal-search__empty">' +
              sEsc(searchModal.getAttribute('data-i18n-no-results') || '').replace('[query]', function () { return sEsc(q); }) + '</p>';
          } else {
            sResults.innerHTML = products.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              var thumb = img ? '<img src="' + sEsc(img) + '" alt="' + sEsc(p.title) + '" loading="lazy">' : '';
              var sub = p.type ? '<span class="muted">' + sEsc(p.type) + '</span>' : '';
              var priceVal = sMoney(p.price);
              var price = priceVal ? '<span class="nordal-search__result-price">' + sEsc(priceVal) + '</span>' : '';
              return '<a class="nordal-search__result" href="' + sEsc(p.url) + '">' +
                '<span class="nordal-search__result-thumb">' + thumb + '</span>' +
                '<span class="nordal-search__result-text"><strong>' + sEsc(p.title) + '</strong>' + sub + '</span>' +
                price + '</a>';
            }).join('');
          }
          if (sDefault) { sDefault.hidden = true; }
          sResults.hidden = false;
        };
        var showDefault = function () {
          if (sResults) { sResults.innerHTML = ''; sResults.hidden = true; }
          if (sDefault) { sDefault.hidden = false; }
        };
        var doSearch = function (q) {
          var url = sUrl + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
              renderResults(products, q);
            })
            .catch(function () {});
        };
        if (sInput) {
          sInput.addEventListener('input', function () {
            var q = sInput.value.trim();
            if (sTimer) { clearTimeout(sTimer); }
            if (q.length < 2) { showDefault(); return; }
            sTimer = setTimeout(function () { doSearch(q); }, 200);
          });
        }
        if (sForm) {
          sForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var q = sInput ? sInput.value.trim() : '';
            if (q.length >= 2) { doSearch(q); } else { showDefault(); }
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-legal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(text, fallback) {
      var base = (text || '').toLowerCase()
        .replace(/[^a-z0-9À-ɏ\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      return base || fallback;
    }

    function initCollapse(root) {
      var content = root.querySelector('[data-legal-content]');
      if (!content || content.getAttribute('data-legal-collapse') !== 'true') return;
      if (content.hasAttribute('data-collapse-ready')) return;
      content.setAttribute('data-collapse-ready', 'true');

      var visibleCount = parseInt(content.getAttribute('data-legal-collapse-visible'), 10) || 2;
      var headings = [];
      for (var i = 0; i < content.children.length; i++) {
        if (content.children[i].tagName === 'H2') headings.push(content.children[i]);
      }

      var cut = null;
      if (headings.length > visibleCount) {
        cut = headings[visibleCount];
      } else if (content.children.length > visibleCount) {
        cut = content.children[visibleCount];
      }
      if (!cut) return;

      var more = document.createElement('div');
      more.className = 'legal-rte-more';
      more.hidden = true;

      var node = cut;
      var toMove = [];
      while (node) {
        toMove.push(node);
        node = node.nextElementSibling;
      }
      toMove.forEach(function (el) { more.appendChild(el); });
      content.appendChild(more);

      var labelMore = content.getAttribute('data-legal-collapse-more') || 'Lees meer';
      var labelLess = content.getAttribute('data-legal-collapse-less') || 'Toon minder';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'legal-rte-toggle link-underline';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>' + labelMore + '</span>' +
        '<svg class="chevron" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">' +
        '<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      btn.addEventListener('click', function () {
        var expand = more.hidden;
        more.hidden = !expand;
        btn.setAttribute('aria-expanded', String(expand));
        btn.querySelector('span').textContent = expand ? labelLess : labelMore;
        btn.classList.toggle('is-open', expand);
      });

      content.parentNode.insertBefore(btn, content.nextSibling);
    }

    function initAccordion(root) {
      var content = root.querySelector('[data-legal-content]');
      if (!content || content.getAttribute('data-legal-accordion') !== 'true') return;
      if (content.hasAttribute('data-accordion-ready')) return;
      content.setAttribute('data-accordion-ready', 'true');

      // Group the flat H2/H3/p/ul/... children per H2 section, same traversal as
      // initCollapse: each H2 plus everything up to (not including) the next H2.
      var groups = [];
      var current = null;
      Array.prototype.slice.call(content.children).forEach(function (el) {
        if (el.tagName === 'H2') {
          current = { heading: el, rest: [] };
          groups.push(current);
        } else if (current) {
          current.rest.push(el);
        } else {
          // Content before the first H2 (e.g. a lone intro paragraph) - leave in place,
          // don't force it into an accordion item that has no real heading.
        }
      });
      if (groups.length < 2) return;

      groups.forEach(function (group, i) {
        var details = document.createElement('details');
        details.className = 'legal-acc-item';
        if (i === 0) details.open = true;

        var summary = document.createElement('summary');
        summary.className = 'legal-acc-q';
        var label = document.createElement('span');
        label.textContent = group.heading.textContent;
        var sign = document.createElement('span');
        sign.className = 'legal-acc-sign';
        sign.setAttribute('aria-hidden', 'true');
        summary.appendChild(label);
        summary.appendChild(sign);

        var body = document.createElement('div');
        body.className = 'legal-acc-a';
        group.rest.forEach(function (el) { body.appendChild(el); });

        details.appendChild(summary);
        details.appendChild(body);
        content.replaceChild(details, group.heading);
      });
    }

    function initLegal(root) {
      initAccordion(root);
      initCollapse(root);

      var aside = root.querySelector('[data-legal-toc]');
      var content = root.querySelector('[data-legal-content]');
      if (!aside || !content) return;

      var linksWrap = aside.querySelector('[data-legal-toc-links]');
      var headings = content.querySelectorAll('h2');
      if (!linksWrap || headings.length < 2) return;

      var anchors = [];
      headings.forEach(function (h, i) {
        if (!h.id) h.id = slugify(h.textContent, 'sectie-' + (i + 1));
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(h.id);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + h.id);
          }
        });
        linksWrap.appendChild(a);
        anchors.push({ link: a, heading: h });
      });

      aside.hidden = false;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            anchors.forEach(function (item) {
              item.link.classList.toggle('is-current', item.heading === entry.target);
            });
          });
        }, { rootMargin: '-96px 0px -65% 0px', threshold: 0 });
        anchors.forEach(function (item) { observer.observe(item.heading); });
      }
    }

    function run() {
      document.querySelectorAll('.nordal-legal').forEach(initLegal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.nordal-legal');
      if (el) initLegal(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMainProduct(root) {
      if (!root || root.dataset.pdpInit === '1') return;
      root.dataset.pdpInit = '1';

      var form = root.querySelector('[data-pdp-form]');
      var mainImg = root.querySelector('[data-pdp-main] img');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var unitEl = root.querySelector('[data-pdp-unit]');
      var idInput = root.querySelector('[data-pdp-variant-id]');
      var addBtn = root.querySelector('[data-pdp-add]');
      var addText = root.querySelector('[data-pdp-add-text]');
      var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
      var bundleBtn = root.querySelector('[data-pdp-bundle]');
      var etaEl = root.querySelector('[data-pdp-eta]');

      var variants = [];
      var dataEl = root.querySelector('[data-pdp-variants]');
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      }

      var addLabel = (addBtn && addBtn.getAttribute('data-add-label')) || (addText ? addText.textContent.trim() : (root.getAttribute('data-i18n-add') || ''));
      var soldOutLabel = (addBtn && addBtn.getAttribute('data-soldout-label')) || root.getAttribute('data-i18n-sold-out') || '';

      /* ---- Gallery: thumbnails + arrows ----
         Every media item gets a thumbnail, four of them in view at a time. The rest
         stay on the horizontal track and are reached with the arrows beside it, so
         nothing is hidden without a control pointing at it. ---- */
      var galleryIndex = 0;
      var thumbTrack = root.querySelector('[data-pdp-thumbs]');
      var activeThumbOnLoad = root.querySelector('[data-pdp-thumb].active');
      var thumbsPrev = root.querySelector('[data-pdp-thumbs-prev]');
      var thumbsNext = root.querySelector('[data-pdp-thumbs-next]');

      function updateThumbArrows() {
        if (!thumbTrack || !thumbsPrev || !thumbsNext) return;
        var max = thumbTrack.scrollWidth - thumbTrack.clientWidth;
        thumbsPrev.disabled = thumbTrack.scrollLeft <= 1;
        thumbsNext.disabled = thumbTrack.scrollLeft >= max - 1;
      }
      function scrollThumbs(dir) {
        if (!thumbTrack) return;
        thumbTrack.scrollBy({ left: dir * thumbTrack.clientWidth, behavior: 'smooth' });
      }
      function revealThumb(btn) {
        if (!thumbTrack) return;
        var viewLeft = thumbTrack.scrollLeft;
        var viewRight = viewLeft + thumbTrack.clientWidth;
        if (btn.offsetLeft < viewLeft) {
          thumbTrack.scrollTo({ left: btn.offsetLeft, behavior: 'smooth' });
        } else if (btn.offsetLeft + btn.offsetWidth > viewRight) {
          thumbTrack.scrollTo({ left: btn.offsetLeft + btn.offsetWidth - thumbTrack.clientWidth, behavior: 'smooth' });
        }
      }
      if (activeThumbOnLoad) {
        var activeIdx = thumbs.indexOf(activeThumbOnLoad);
        if (activeIdx > -1) galleryIndex = activeIdx;
      }
      if (thumbsPrev) thumbsPrev.addEventListener('click', function () { scrollThumbs(-1); });
      if (thumbsNext) thumbsNext.addEventListener('click', function () { scrollThumbs(1); });
      if (thumbTrack) {
        thumbTrack.addEventListener('scroll', updateThumbArrows, { passive: true });
        window.addEventListener('resize', updateThumbArrows);
        updateThumbArrows();
      }

      function selectThumb(i) {
        if (!thumbs.length) return;
        i = ((i % thumbs.length) + thumbs.length) % thumbs.length;
        galleryIndex = i;
        var btn = thumbs[i];
        if (mainImg) {
          var url = btn.getAttribute('data-media-url');
          var alt = btn.getAttribute('data-media-alt') || '';
          if (url) {
            mainImg.src = url;
            mainImg.removeAttribute('srcset');
            mainImg.setAttribute('alt', alt);
          }
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        revealThumb(btn);
      }
      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { selectThumb(i); });
      });
      var prevBtn = root.querySelector('[data-pdp-prev]');
      var nextBtn = root.querySelector('[data-pdp-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { selectThumb(galleryIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { selectThumb(galleryIndex + 1); });

      /* ---- Quantity stepper ---- */
      var qtyInput = root.querySelector('[data-pdp-qty-input]');
      var minus = root.querySelector('[data-pdp-qty-minus]');
      var plus = root.querySelector('[data-pdp-qty-plus]');
      function getQty() { var v = parseInt(qtyInput && qtyInput.value, 10); return isNaN(v) || v < 1 ? 1 : v; }
      if (minus) minus.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, getQty() - 1); });
      if (plus) plus.addEventListener('click', function () { if (qtyInput) qtyInput.value = getQty() + 1; });

      /* ---- Bundle toggle (div as button) ---- */
      var bundleOn = false;
      function toggleBundle() {
        bundleOn = !bundleOn;
        bundleBtn.setAttribute('aria-pressed', bundleOn ? 'true' : 'false');
        update();
      }
      var bundleSelect = root.querySelector('[data-pdp-bundle-select]');
      var bundleTitleEl = root.querySelector('[data-pdp-bundle-title]');

      /* Totaal + bundelprijs van de partner die nú in de picker staat. */
      function bundleMoney() {
        if (!bundleSelect) return null;
        var opt = bundleSelect.options[bundleSelect.selectedIndex];
        if (!opt) return null;
        var total = opt.getAttribute('data-bundle-total');
        var price = opt.getAttribute('data-bundle-bundle');
        return total && price ? { total: total, price: price } : null;
      }
      if (bundleBtn) {
        bundleBtn.addEventListener('click', function (e) {
          /* Clicks landing on the inline <select> or its chevron must not toggle. */
          if (bundleSelect && bundleSelect.contains(e.target)) return;
          var wrap = bundleBtn.querySelector('.pdp-bundle-select-wrap');
          if (wrap && wrap.contains(e.target)) return;
          toggleBundle();
        });
        bundleBtn.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
            if (bundleSelect && bundleSelect === document.activeElement) return;
            e.preventDefault();
            toggleBundle();
          }
        });
      }

      /* ---- Bundle picker: swap the selected partner product ---- */
      if (bundleSelect && bundleBtn) {
        /* The select itself must stop click/mousedown from bubbling to the bundle-toggle. */
        ['click', 'mousedown', 'touchstart'].forEach(function (evt) {
          bundleSelect.addEventListener(evt, function (e) { e.stopPropagation(); });
        });
        bundleSelect.addEventListener('change', function () {
          var opt = bundleSelect.options[bundleSelect.selectedIndex];
          if (!opt) return;
          var vid = opt.value;
          var title = opt.getAttribute('data-bundle-title') || '';
          var price = opt.getAttribute('data-bundle-price') || '';
          if (vid) bundleBtn.setAttribute('data-bundle-variant-id', vid);
          if (price) bundleBtn.setAttribute('data-bundle-price', price);
          if (title) bundleBtn.setAttribute('data-bundle-title', title);
          if (title && bundleTitleEl) bundleTitleEl.textContent = title;
          if (typeof update === 'function') update();
        });
      }

      /* ---- Variant resolution ---- */
      function selectedOptions() {
        var opts = [];
        optionInputs.forEach(function (inp) {
          if (inp.checked) {
            var pos = parseInt(inp.getAttribute('data-pdp-option'), 10);
            opts[pos - 1] = inp.value;
          }
        });
        return opts;
      }

      function matchVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < opts.length; j++) {
            if (v.options[j] !== opts[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* ---- Sticky size pills sync ---- */
      var stickySizes = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-sticky-size]'));
      stickySizes.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var pos = pill.getAttribute('data-option-position');
          var val = pill.getAttribute('data-option-value');
          var target = root.querySelector('[data-pdp-option="' + pos + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
          if (!target) {
            optionInputs.forEach(function (inp) {
              if (inp.getAttribute('data-pdp-option') === pos && inp.value === val) target = inp;
            });
          }
          if (target) { target.checked = true; showVariantMedia(update()); }
        });
      });

      function update() {
        if (!variants.length) return;
        var current = matchVariant(selectedOptions()) || variants[0];
        if (idInput) idInput.value = current.id;

        /* The 10%-bundel offer only applies to the 250ml size of the product being viewed. */
        if (bundleBtn) {
          var is250 = String(current.title || '').indexOf('250') !== -1;
          bundleBtn.hidden = !is250;
          if (!is250 && bundleOn) {
            bundleOn = false;
            bundleBtn.setAttribute('aria-pressed', 'false');
          }
        }

        if (bundleOn && current.bundle_price) {
          /* The variant JSON only carries the default partner's total, so the picker's
             own per-option prices win whenever a partner has been chosen. */
          var bm = bundleMoney();
          if (priceEl) priceEl.innerHTML = bm ? bm.price : current.bundle_price;
          if (compareEl) { compareEl.innerHTML = bm ? bm.total : current.bundle_total; compareEl.hidden = false; }
          if (unitEl) unitEl.textContent = root.getAttribute('data-i18n-per-bundle') || '';
        } else {
          if (priceEl) priceEl.innerHTML = current.price;
          if (compareEl) {
            if (current.compare_at_price) { compareEl.innerHTML = current.compare_at_price; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (unitEl) unitEl.textContent = '/ ' + current.title;
        }

        if (addBtn) {
          addBtn.disabled = !current.available;
          if (addText) addText.textContent = current.available ? addLabel : soldOutLabel;
        }

        /* "Op voorraad" mag niet blijven staan bij een maat die uitverkocht is. */
        if (etaEl) etaEl.hidden = !current.available;

        /* reflect selection onto sticky pills (first option only) */
        if (stickySizes.length) {
          var firstVal = (selectedOptions()[0]) || (current.options && current.options[0]);
          stickySizes.forEach(function (pill) {
            pill.classList.toggle('active', pill.getAttribute('data-option-value') === firstVal);
          });
        }

        return current;
      }

      /* ---- Swap the stage photo to the chosen variant's image.
         Only runs on a real size change (see the option `change` listener below) - the
         page must always open on the product's first photo (product.media.first,
         already rendered server-side), never swapped for the 250ml default's own
         variant image on load. ---- */
      function showVariantMedia(variant) {
        if (!variant || !mainImg) return;
        /* Prefer an existing thumbnail so its active state + the prev/next arrows stay in sync */
        if (variant.media_id != null) {
          for (var i = 0; i < thumbs.length; i++) {
            if (String(thumbs[i].getAttribute('data-media-id')) === String(variant.media_id)) {
              selectThumb(i);
              return;
            }
          }
        }
        /* Variant image isn't one of the rendered thumbs: swap the stage photo directly.
           Reset galleryIndex so the prev/next arrows resume cleanly from the start of
           the thumb track (next -> first thumb) instead of a now-stale position. */
        if (variant.image) {
          mainImg.src = variant.image;
          mainImg.removeAttribute('srcset');
          if (variant.image_alt) mainImg.setAttribute('alt', variant.image_alt);
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          galleryIndex = -1;
        }
      }

      optionInputs.forEach(function (inp) {
        inp.addEventListener('change', function () { showVariantMedia(update()); });
      });

      /* ---- AJAX add-to-cart (with optional bundle partner) ---- */
      function addToCart() {
        if (!window.fetch) { if (form) form.submit(); return; }
        if (addBtn) addBtn.disabled = true;
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var qty = getQty();
        var items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
        var discountCode = '';
        if (bundleOn && bundleBtn) {
          var pid = parseInt(bundleBtn.getAttribute('data-bundle-variant-id'), 10);
          if (pid) items.push({ id: pid, quantity: qty });
          discountCode = bundleBtn.getAttribute('data-bundle-discount-code') || '';
        }
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data && data.status && data.status !== 200) {
            if (addBtn) addBtn.disabled = false;
            if (form) form.submit();
            return;
          }
          /* A discount code configured in the section settings gets attached to the
             session by requesting /discount/<code> - the browser still processes the
             Set-Cookie from a same-origin fetch, so this stays in the drawer instead
             of forcing a full-page redirect to /cart. */
          if (discountCode) {
            fetch(root_url + 'discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' })
              .catch(function () {})
              .then(function () {
                if (addBtn) addBtn.disabled = false;
                document.dispatchEvent(new CustomEvent('nordal:cart:added'));
              });
          } else {
            if (addBtn) addBtn.disabled = false;
            document.dispatchEvent(new CustomEvent('nordal:cart:added'));
          }
        }).catch(function () {
          if (addBtn) addBtn.disabled = false;
          if (form) form.submit();
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          addToCart();
        });
      }
      var stickyAdd = root.querySelector('[data-pdp-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(); });

      /* ---- Sticky bar show/hide ---- */
      var sticky = root.querySelector('[data-pdp-sticky]');
      var buyBox = root.querySelector('.pdp-buy');
      if (sticky && buyBox) {
        var shown = false;
        var footer = document.querySelector('.nordal-footer');
        var footerBasePad = footer ? (parseFloat(window.getComputedStyle(footer).paddingBottom) || 0) : 0;
        function onScroll() {
          var r = buyBox.getBoundingClientRect();
          var show = r.bottom < 80;
          /* The bar is fixed at the viewport bottom (on every breakpoint) and would cover
             the footer; reserve scroll space equal to the bar height while it shows so the
             full footer can be scrolled clear of it. */
          if (footer) footer.style.paddingBottom = show ? (footerBasePad + sticky.offsetHeight) + 'px' : '';
          if (show === shown) return;
          shown = show;
          sticky.classList.toggle('is-show', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
          if (stickyAdd) { if (show) stickyAdd.removeAttribute('tabindex'); else stickyAdd.setAttribute('tabindex', '-1'); }
          sticky.querySelectorAll('[data-pdp-sticky-size]').forEach(function (el) {
            if (show) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll();
      }

      /* Auto-select 250ml if not pre-selected via URL */
      if (!window.location.search.includes('variant=')) {
        var pref250 = null;
        for (var oi = 0; oi < optionInputs.length; oi++) {
          if (optionInputs[oi].value.indexOf('250') !== -1) { pref250 = optionInputs[oi]; break; }
        }
        if (pref250 && !pref250.checked) { pref250.checked = true; }
      }

      update();
    }

    // De betaalicoontjes wikkelen vanzelf naar een lelijke staart (8 op de eerste
    // rij, 4 op de tweede). Hier tellen we hoeveel er daadwerkelijk op een rij
    // passen, verdelen we het totaal gelijk over dat aantal rijen en forceren we
    // die verdeling met onzichtbare breekpunten. Past alles op een rij, dan
    // gebeurt er niets.
    function balancePayRow(row) {
      Array.prototype.slice.call(row.querySelectorAll('.pay-break')).forEach(function (br) {
        row.removeChild(br);
      });

      var items = Array.prototype.slice.call(row.querySelectorAll('.pay-icon'));
      if (items.length < 3) return;

      // Natuurlijke wikkeling uitlezen: alles met dezelfde offsetTop als het
      // eerste icoon vormt de eerste rij, en dat is het maximum dat past.
      var firstTop = items[0].offsetTop;
      var perRowMax = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetTop !== firstTop) break;
        perRowMax++;
      }
      if (perRowMax < 1 || perRowMax >= items.length) return;

      var rows = Math.ceil(items.length / perRowMax);
      var perRow = Math.ceil(items.length / rows);
      if (perRow >= items.length) return;

      for (var j = perRow; j < items.length; j += perRow) {
        var brk = document.createElement('span');
        brk.className = 'pay-break';
        brk.setAttribute('aria-hidden', 'true');
        row.insertBefore(brk, items[j]);
      }
    }

    function initPayRows(root) {
      var rows = Array.prototype.slice.call(root.querySelectorAll('.pay-row'));
      if (!rows.length) return;
      function run() { rows.forEach(balancePayRow); }
      run();
      // De iconen zijn inline SVG's, maar webfonts en late layoutwissels kunnen de
      // breedtes nog verschuiven; een tweede meting na load vangt dat af.
      window.addEventListener('load', run);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(run, 150);
      });
    }

    function boot() {
      document.querySelectorAll('.nordal-main-product').forEach(function (el) {
        initMainProduct(el);
        initPayRows(el);
      });
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.nordal-main-product');
      if (el) { el.dataset.pdpInit = ''; initMainProduct(el); initPayRows(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scroll-scrubbed ingredient clip. Instead of seeking video.currentTime on
    // scroll (choppy, keyframe-bound), we pre-decode the clip to frame bitmaps
    // once, then a continuous rAF loop lerps toward the scroll-target frame and
    // blits the nearest bitmap to a canvas - buttery in both directions.
    function initSection(section) {
      if (!section || section.dataset.ingInit === '1') return;
      var canvas = section.querySelector('.pdp-ing-canvas');
      if (!canvas) return;
      var src = canvas.getAttribute('data-ing-src');
      var ctx = canvas.getContext && canvas.getContext('2d');
      if (!src || !ctx) return;
      section.dataset.ingInit = '1';
      var media = canvas.closest('.pdp-ing-media');
      var fb = section.querySelector('.pdp-ing-fallback');

      var reduce = false;
      var raf = 0, cancelled = false, frames = [], framesReady = false;
      var curF = 0, lastDrawn = -1, objUrl = null;

      var clamp01 = function (v) { return Math.min(1, Math.max(0, v)); };
      var progress = function () {
        var r = section.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        return clamp01((vh - r.top) / (r.height + vh));
      };
      var markPlaying = function () {
        if (media && !media.classList.contains('is-playing')) media.classList.add('is-playing');
      };
      var useFallback = function () {
        if (media) media.classList.add('use-fallback');
        if (!fb) return;
        if (!fb.src && fb.dataset.src) { fb.src = fb.dataset.src; fb.load(); }
        // Scroll-scrubbed, same as the canvas path - never call .play(), the
        // clip must only move because of scroll position, not on a timer/loop.
        var scrub = function () {
          if (fb.duration) {
            fb.currentTime = progress() * fb.duration;
            markPlaying();
          }
        };
        if (fb.readyState >= 1) {
          scrub();
        } else {
          fb.addEventListener('loadedmetadata', scrub, { once: true });
        }
        window.addEventListener('scroll', scrub, { passive: true });
        window.addEventListener('resize', scrub, { passive: true });
      };
      var seekTo = function (v, t) {
        return new Promise(function (res) {
          var h = function () { v.removeEventListener('seeked', h); res(); };
          v.addEventListener('seeked', h);
          try { v.currentTime = t; } catch (e) { res(); }
        });
      };
      var fitDraw = function (img, iw, ih) {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var rect = canvas.getBoundingClientRect();
        var cw = Math.max(1, Math.round(rect.width * dpr));
        var ch = Math.max(1, Math.round(rect.height * dpr));
        if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch; }
        ctx.clearRect(0, 0, cw, ch);
        var s = Math.min(cw / iw, ch / ih);
        var dw = iw * s, dh = ih * s;
        ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
        markPlaying();
      };

      var newVideo = function () {
        var v = document.createElement('video');
        v.muted = true; v.playsInline = true; v.preload = 'auto'; v.crossOrigin = 'anonymous';
        return v;
      };
      // Fetch as a same-origin blob URL so the canvas is never tainted.
      var withVideo = function (onReady) {
        var v = newVideo();
        fetch(src).then(function (r) { return r.blob(); }).then(function (blob) {
          if (cancelled) return;
          objUrl = URL.createObjectURL(blob);
          v.src = objUrl;
          var go = function () { v.removeEventListener('loadeddata', go); onReady(v); };
          v.addEventListener('loadeddata', go);
          v.load();
        }).catch(function () { useFallback(); });
      };

      if (reduce || !window.createImageBitmap) {
        // Static: draw a single mid frame, no scroll animation.
        withVideo(function (v) {
          seekTo(v, (v.duration || 0) / 2).then(function () {
            if (!cancelled) fitDraw(v, v.videoWidth || 720, v.videoHeight || 900);
          });
        });
        return;
      }

      var draw = function (bmp) { if (bmp) fitDraw(bmp, bmp.width, bmp.height); };
      var loop = function () {
        raf = requestAnimationFrame(loop);
        if (!framesReady || frames.length < 2) return;
        var pp = progress();
        var ppc = Math.min(1, pp / 0.80);   // finish the ping-pong a touch early
        var tri = 1 - Math.abs(2 * ppc - 1); // forward to mid, then back
        var targetF = tri * (frames.length - 1);
        curF += (targetF - curF) * 0.18;     // lerp = the "extreem soepel"
        if (Math.abs(targetF - curF) < 0.02) curF = targetF;
        var idx = Math.round(curF);
        if (idx !== lastDrawn && frames[idx]) { draw(frames[idx]); lastDrawn = idx; }
      };

      var extract = function (v) {
        var dur = v.duration || 0;
        if (!dur) return;
        var count = Math.max(2, Math.min(170, Math.round(dur * 24)));
        var vw = v.videoWidth || 720, vh = v.videoHeight || 900;
        var scale = Math.min(1, 660 / vw);
        var w = Math.round(vw * scale), h = Math.round(vh * scale);
        var off = document.createElement('canvas'); off.width = w; off.height = h;
        var octx = off.getContext('2d');
        var end = Math.max(0, dur - 0.05);
        var chain = Promise.resolve();
        var step = function (i) {
          return seekTo(v, (i / (count - 1)) * end).then(function () {
            if (cancelled) return;
            octx.drawImage(v, 0, 0, w, h);
            return createImageBitmap(off).then(function (b) { frames[i] = b; }, function () { frames[i] = null; })
              .then(function () { if (i === 0) { framesReady = true; lastDrawn = -1; } });
          });
        };
        for (var i = 0; i < count; i++) {
          (function (i) { chain = chain.then(function () { if (!cancelled) return step(i); }); })(i);
        }
      };

      window.addEventListener('resize', function () { lastDrawn = -1; }, { passive: true });
      withVideo(extract);
      raf = requestAnimationFrame(loop);
      setTimeout(function () { if (!cancelled && !framesReady) useFallback(); }, 3500);
    }

    // The clip is multiple MB; never fetch it during the initial page load.
    // Init (which downloads + pre-decodes the video) only starts once the
    // section is within a screen of the viewport.
    function lazyInit(section) {
      if (!section || section.dataset.ingObserved === '1') return;
      section.dataset.ingObserved = '1';
      if (!('IntersectionObserver' in window)) { initSection(section); return; }
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); initSection(section); break; }
        }
      }, { rootMargin: '100% 0px' });
      io.observe(section);
    }

    function initAll() {
      var list = document.querySelectorAll('.nordal-pdp-ingredients');
      for (var i = 0; i < list.length; i++) lazyInit(list[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('.nordal-pdp-ingredients') : null;
      if (el) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.nordal-pdp-reviews [data-pdp-reviews-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-pdp-reviews-track]');
      var nav = slider.querySelector('[data-pdp-reviews-nav]');
      var prev = slider.querySelector('[data-pdp-reviews-prev]');
      var next = slider.querySelector('[data-pdp-reviews-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.pdp-review');
        return card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
      }

      /* De rail bloedt door tot de schermrand en vangt dat op met padding; scrollLeft 0
         zet de eerste kaart daardoor tegen de schermrand in plaats van onder de kop.
         minPos is de rustpositie waarin kaart en kop weer uitlijnen. */
      function edgePad() {
        return parseFloat(getComputedStyle(track).paddingLeft) || 0;
      }
      function minPos() { return edgePad(); }
      function seatRail() {
        if (track.scrollLeft < minPos()) track.scrollLeft = minPos();
      }

      function updateNav() {
        if (!nav) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var scrollable = maxScroll > 4;
        nav.hidden = !scrollable;
        if (!scrollable) return;
        /* Zodra de rail rondloopt heeft hij geen begin of eind meer, dus de pijlen
           blijven altijd bruikbaar. */
        if (loopWidth > 0) {
          if (prev) prev.disabled = false;
          if (next) next.disabled = false;
          return;
        }
        if (prev) prev.disabled = track.scrollLeft <= minPos() + 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - edgePad() - 2;
      }

      /* Bij een rondlopende rail eerst een set verspringen als je tegen een uiteinde
         aan klikt; op dat punt staat exact hetzelfde beeld, dus je ziet er niets van. */
      function nudge(delta) {
        if (loopWidth > 0) {
          if (delta < 0 && track.scrollLeft < -delta) track.scrollLeft += loopWidth;
          else if (delta > 0 && track.scrollLeft > loopWidth) track.scrollLeft -= loopWidth;
        }
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
      if (next) next.addEventListener('click', function () { nudge(step()); });
      if (prev) prev.addEventListener('click', function () { nudge(-step()); });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', function () { seatRail(); updateNav(); });
      seatRail();
      updateNav();

      /* De rail draait rond in plaats van op te raken: de kaartenset wordt eenmaal
         gekloond achter het origineel geplakt, en zodra de drift precies een set ver
         is gekomen springt de scrollpositie een set terug. Op dat punt staat er exact
         hetzelfde beeld, dus de sprong is onzichtbaar en er komt altijd een volgende
         review aan. ~18px per seconde: net genoeg om te zien dat het leeft, niet zo
         veel dat het de tekst wegtrekt. Bewust niet afhankelijk van
         prefers-reduced-motion. Pauzeert bij hover, interactie, verborgen tab en
         zodra het blok minder dan half in beeld staat. */
      var rafId = null;
      var hovering = false;
      var holdUntil = 0;
      var lastTs = 0;
      var pos = 0;
      var loopWidth = 0;
      var AUTO_SPEED = 18;
      var AUTO_HOLD = 6000;
      var originals = Array.prototype.slice.call(track.children);

      /* De kaarten zijn `.reveal`-elementen: ze staan op opacity 0 tot de globale
         reveal-observer ze `.in` geeft. Die observer draait eenmalig bij load en
         ziet alleen wat er dan echt in beeld staat. Kaarten die verderop in de rail
         staan zijn horizontaal weggeclipt en dus nog niet onthuld, en de klonen die
         hieronder ontstaan worden sowieso nooit meer geobserveerd. Resultaat: na een
         halve minuut autoplay schoof er een onzichtbare kaart in beeld - het gat /
         de "missende" kaart. Op dit punt staat het blok al half in beeld, dus alles
         in de rail mag gewoon zichtbaar zijn. */
      function revealAll(el) {
        if (el.classList.contains('reveal')) el.classList.add('in');
        Array.prototype.forEach.call(el.querySelectorAll('.reveal'), function (child) {
          child.classList.add('in');
        });
      }
      function stripReveal(el) {
        if (el.classList.contains('reveal')) { el.classList.remove('reveal'); el.style.transitionDelay = '0s'; }
        Array.prototype.forEach.call(el.querySelectorAll('.reveal'), function (child) {
          child.classList.remove('reveal');
          child.style.transitionDelay = '0s';
        });
      }

      function buildLoop() {
        if (track.dataset.looped === 'true' || originals.length < 2) return;
        if (track.scrollWidth - track.clientWidth <= 4) return;
        originals.forEach(revealAll);
        originals.forEach(function (card) {
          var clone = card.cloneNode(true);
          stripReveal(clone);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-clone', '');
          /* Klonen zijn puur decor: haal ze uit de tabvolgorde. */
          Array.prototype.forEach.call(clone.querySelectorAll('a, button'), function (el) {
            el.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
        });
        track.dataset.looped = 'true';
      }

      function measureLoop() {
        var firstClone = track.querySelector('[data-clone]');
        loopWidth = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
      }

      function wrap(v) {
        if (loopWidth <= 0) return v;
        while (v >= loopWidth) v -= loopWidth;
        while (v < 0) v += loopWidth;
        return v;
      }

      function autoFrame(ts) {
        rafId = requestAnimationFrame(autoFrame);
        var dt = lastTs ? Math.min(100, ts - lastTs) : 0;
        lastTs = ts;

        /* Re-sync na een veeg of een pijlklik die de track onder ons verschoof. */
        if (Math.abs(track.scrollLeft - pos) > 1.5) pos = track.scrollLeft;
        if (!dt || hovering || document.hidden || Date.now() < holdUntil) return;
        if (loopWidth <= 0) return;

        pos = wrap(pos + AUTO_SPEED * dt / 1000);
        track.scrollLeft = pos;
      }
      function autoPlay() {
        if (rafId) return;
        buildLoop();
        measureLoop();
        lastTs = 0;
        pos = track.scrollLeft;
        rafId = requestAnimationFrame(autoFrame);
      }
      function autoStop() { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }
      /* Terug naar de eerste review zodra het blok volledig weg is, zodat je bij een
         tweede bezoek niet midden in de reeks binnenkomt. Gebeurt buiten beeld. */
      function autoRewind() {
        track.scrollLeft = minPos();
        pos = minPos();
      }
      function autoHold() { holdUntil = Date.now() + AUTO_HOLD; }

      slider.addEventListener('mouseenter', function () { hovering = true; });
      slider.addEventListener('mouseleave', function () { hovering = false; });
      slider.addEventListener('focusin', autoHold);
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
        slider.addEventListener(evt, autoHold, { passive: true });
      });
      window.addEventListener('resize', measureLoop);

      if ('IntersectionObserver' in window) {
        var autoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            /* Op intersectionRatio toetsen, niet op isIntersecting: die is al true
               bij een enkele zichtbare pixel, ongeacht de thresholds - daardoor liep
               de rail toch weer leeg terwijl het blok nog onderaan stond te piepen. */
            if (entry.intersectionRatio >= 0.5) { autoPlay(); return; }
            autoStop();
            if (entry.intersectionRatio === 0) autoRewind();
          });
        }, { threshold: [0, 0.5] });
        autoIo.observe(slider);
      } else {
        autoPlay();
      }

      /* Bewust GEEN wheel-handler die verticale scroll onderschept en met
         window.scrollBy doorzet: dat vervangt de native momentum-scroll door een
         kale pixel-voor-pixel sprong, en dan kruipt de pagina zodra je met de
         cursor over een review staat. De rail is verticaal niet scrollbaar
         (overflow-y: hidden) en touch-action: pan-x laat verticaal vegen door,
         dus verticale scroll gaat vanzelf naar de pagina. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUGC(stage) {
      if (!stage || stage.dataset.ugcInit === '1') return;
      stage.dataset.ugcInit = '1';

      var cards = Array.prototype.slice.call(stage.querySelectorAll('[data-ugc-card]'));
      var n = cards.length;
      if (!n) return;
      var center = Math.floor(n / 2);
      var activated = false;

      function playCenter() {
        if (!activated) return;
        cards.forEach(function (card, i) {
          var v = card.querySelector('.ugc-phone-screen video');
          if (!v) return;
          if (i === center) {
            try {
              if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
              v.currentTime = 0; var p = v.play(); if (p) p.catch(function () {});
            } catch (e) {}
          }
          else { try { v.pause(); } catch (e) {} }
        });
      }

      function render() {
        cards.forEach(function (card, i) {
          card.classList.remove('ugc-center', 'ugc-near', 'ugc-far', 'ugc-slot--2', 'ugc-slot--1', 'ugc-slot-0', 'ugc-slot-1', 'ugc-slot-2');
          var raw = (i - center + n) % n;
          var off = raw <= n / 2 ? raw : raw - n;
          if (off < -2 || off > 2) return;
          if (off === 0) card.classList.add('ugc-center', 'ugc-slot-0');
          else if (Math.abs(off) === 1) card.classList.add('ugc-near', off === -1 ? 'ugc-slot--1' : 'ugc-slot-1');
          else card.classList.add('ugc-far', off === -2 ? 'ugc-slot--2' : 'ugc-slot-2');
        });
        playCenter();
      }

      function go(k) { center = ((k % n) + n) % n; render(); }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { if (i !== center) go(i); });
      });
      var prev = stage.querySelector('[data-ugc-prev]');
      var next = stage.querySelector('[data-ugc-next]');
      if (prev) prev.addEventListener('click', function () { go(center - 1); });
      if (next) next.addEventListener('click', function () { go(center + 1); });

      render();

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { io.disconnect(); activated = true; playCenter(); }
          });
        }, { rootMargin: '400px 0px' });
        io.observe(stage);
      } else {
        activated = true;
        playCenter();
      }
    }

    function boot() { document.querySelectorAll('[data-ugc]').forEach(initUGC); }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-ugc]');
      if (el) { el.dataset.ugcInit = ''; initUGC(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = document.querySelectorAll('[data-count-stats]');
    if (!groups.length) return;

    var reduce = false;

    function setFinal(el) {
      var to = parseInt(el.getAttribute('data-count-to'), 10) || 0;
      el.textContent = to + (el.getAttribute('data-count-suffix') || '');
    }

    function run(el) {
      var to = parseInt(el.getAttribute('data-count-to'), 10) || 0;
      var suffix = el.getAttribute('data-count-suffix') || '';
      var dur = 2200;
      var start = null;

      function tick(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = to + suffix;
      }
      requestAnimationFrame(tick);
      setTimeout(function () { el.textContent = to + suffix; }, dur + 600);
    }

    groups.forEach(function (group) {
      var nums = group.querySelectorAll('[data-count-to]');
      if (!nums.length) return;

      if (reduce || !('IntersectionObserver' in window)) {
        nums.forEach(setFinal);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          nums.forEach(run);
          io.disconnect();
        });
      }, { threshold: 0.4 });
      io.observe(group);
    });
  })();

  (function () {
    var band = document.querySelector('.nordal-problem .problem-band-text');
    if (!band) return;
    var words = Array.prototype.slice.call(band.querySelectorAll('.pb-word'));
    if (!words.length) return;

    var offsets = {
      'pb-word--left': [-40, 0],
      'pb-word--right': [40, 0],
      'pb-word--down': [0, -34]
    };

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

    var ticking = false;
    function apply() {
      ticking = false;
      var rect = band.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* progress 0 = band just entering the bottom of the viewport, 1 = band reached ~30% up the viewport.
         Wider window than a single screen height so the reveal stays visible as it plays out,
         even when the band is tall (e.g. the stacked mobile layout). */
      var start = vh * 1.05 - 200;
      var end = vh * 0.3 - 200;
      var raw = (start - rect.top) / (start - end);
      var progress = clamp(raw, 0, 1);
      var eased = 1 - Math.pow(1 - progress, 3);

      var staggerStep = 0.12;
      var staggerDenom = Math.max(0.01, 1 - (words.length - 1) * staggerStep);
      words.forEach(function (w, i) {
        var key = w.classList.contains('pb-word--left') ? 'pb-word--left'
          : w.classList.contains('pb-word--right') ? 'pb-word--right' : 'pb-word--down';
        var off = offsets[key];
        var stagger = clamp((eased - i * staggerStep) / staggerDenom, 0, 1);
        var x = off[0] * (1 - stagger);
        var y = off[1] * (1 - stagger);
        w.style.opacity = stagger;
        w.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  (function () {
    /* Touch-only stand-in for the desktop hover swap: the photo auto-advances to the
       second shot and back every ~2.5s while the card is on screen, and a swipe left/
       right jumps straight there and restarts the timer from that point. */
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;

    var cards = Array.prototype.slice.call(
      document.querySelectorAll('.nordal-problem .problem-card')
    ).filter(function (card) { return card.querySelector('.problem-photo-hover'); });
    if (!cards.length) return;

    var SWIPE_THRESHOLD = 24;
    var SWIPE_INTENT = 12;
    /* 2.5s was zo kort dat de kaarten voortdurend stonden te knipperen; op ~6.5s
       zie je elke foto echt even staan voordat de volgende inschuift. */
    var AUTO_INTERVAL_MS = 6500;

    cards.forEach(function (card) {
      /* Listen on the card itself, not just .problem-photo: the gradient overlay
         (.problem-card-grad) and title/text sit visually on top of the photo, so a
         real finger touch there never reaches a listener bound to .problem-photo. */
      var startX = 0;
      var startY = 0;
      var swiping = false;
      var timer = null;

      function stopAuto() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function startAuto() {
        if (timer) return;
        timer = setInterval(function () {
          card.classList.toggle('is-flipped');
        }, AUTO_INTERVAL_MS);
      }
      function restartAuto() {
        stopAuto();
        startAuto();
      }

      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startAuto();
            else stopAuto();
          });
        }, { threshold: 0.4 });
        io.observe(card);
      } else {
        startAuto();
      }

      card.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        swiping = false;
      }, { passive: true });

      card.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (!swiping && Math.abs(dx) > SWIPE_INTENT && Math.abs(dx) > Math.abs(dy)) {
          swiping = true;
        }
        /* Once it reads as a horizontal swipe, stop it from also becoming a tap
           that follows the card's link. */
        if (swiping && e.cancelable) e.preventDefault();
      }, { passive: false });

      card.addEventListener('touchend', function (e) {
        if (!swiping) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        if (dx <= -SWIPE_THRESHOLD) card.classList.add('is-flipped');
        else if (dx >= SWIPE_THRESHOLD) card.classList.remove('is-flipped');
        swiping = false;
        restartAuto();
      });
    });
  })();

  (function () {
    var inks = Array.prototype.slice.call(document.querySelectorAll('[data-title-rule]'));
    if (!inks.length) return;

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

    var ticking = false;
    function apply() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      inks.forEach(function (ink) {
        var rect = ink.getBoundingClientRect();
        /* 0 = kop sits just above the fold, 1 = kop has travelled up to ~30% of the screen. */
        var start = vh * 0.92;
        var end = vh * 0.3;
        var p = clamp((start - rect.top) / (start - end), 0, 1);
        /* smoothstep, not ease-out: the rule grows evenly with the scroll instead of
           snapping to full width in the first few pixels. */
        ink.style.setProperty('--rule', (p * p * (3 - 2 * p)).toFixed(4));
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-range"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.nordal-range').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-range-filter]');
      if (!tabs.length) return;
      var cells = root.querySelectorAll('[data-range-grid] .range-cell');
      var empty = root.querySelector('[data-range-empty]');

      function apply(key) {
        var visible = 0;
        cells.forEach(function (cell) {
          var cats = (cell.getAttribute('data-range-cats') || '').split(/\s+/);
          var show = key === 'all' || cats.indexOf(key) !== -1;
          cell.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible !== 0;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-pressed', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-pressed', 'true');
          apply(tab.getAttribute('data-range-filter'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.nordal-social [data-pdp-reviews-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-pdp-reviews-track]');
      var nav = slider.querySelector('[data-pdp-reviews-nav]');
      var prev = slider.querySelector('[data-pdp-reviews-prev]');
      var next = slider.querySelector('[data-pdp-reviews-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.testi');
        return card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
      }

      /* De rail bleedt naar de schermrand met een padding die de kaarten weer op de
         contentkolom zet. Op scrollLeft 0 kijk je dus tegen die lege padding aan.
         Daarom is de bodem van de rail niet 0 maar de padding zelf: dan staat er vanaf
         het eerste moment een review tegen de linkerrand. Idem aan de rechterkant. */
      function edgePad() {
        return parseFloat(getComputedStyle(track).paddingLeft) || 0;
      }
      function minPos() { return edgePad(); }
      function maxPos() {
        return Math.max(minPos(), track.scrollWidth - track.clientWidth - edgePad());
      }
      function seatRail() {
        if (loopWidth > 0) { track.scrollLeft = middleStart(); return; }
        if (track.scrollLeft < minPos()) track.scrollLeft = minPos();
      }

      /* With few review blocks the track can fit fully on wide screens - there's
         nothing to scroll to, so the buttons look "broken". Reflect the real
         scroll state instead of always showing live-looking arrows. */
      function updateNav() {
        if (!nav) return;
        var scrollable = maxPos() - minPos() > 4;
        nav.hidden = !scrollable;
        if (!scrollable) return;
        /* Zodra de rail rondloopt heeft hij geen begin of eind meer, dus de pijlen
           blijven altijd bruikbaar. */
        if (loopWidth > 0) {
          if (prev) prev.disabled = false;
          if (next) next.disabled = false;
          return;
        }
        if (prev) prev.disabled = track.scrollLeft <= minPos() + 2;
        if (next) next.disabled = track.scrollLeft >= maxPos() - 2;
      }

      /* Gewoon scrollen; de reseat-timer hieronder zet de rail na afloop onopvallend
         terug in de middelste set, dus deze hoeft zelf niet meer te springen. */
      function nudge(delta) {
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
      if (next) next.addEventListener('click', function () { nudge(step()); });
      if (prev) prev.addEventListener('click', function () { nudge(-step()); });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', function () { seatRail(); updateNav(); });
      seatRail();
      updateNav();

      /* De rail draait rond in plaats van op te raken: de kaartenset wordt TWEE keer
         gekloond achter het origineel geplakt (origineel + kloon A + kloon B), zodat
         er in beide richtingen altijd een volledige buffer-set staat. Een swipe, een
         pijlklik of iOS-rubberbanding kan je dus nooit voorbij het laatste kaartje
         duwen tot een lege rand - er staat altijd een volgende review klaar.
         Zodra de rail tot rust komt (scroll-einde) wordt de positie onopvallend
         teruggezet naar de middelste set, zodat er weer aan beide kanten ruimte is
         om verder te bladeren. Op dat punt staat er exact hetzelfde beeld, dus de
         sprong is onzichtbaar. ~18px per seconde automatisch: net genoeg om te zien
         dat het leeft, niet zoveel dat het de tekst wegtrekt. Bewust niet afhankelijk
         van prefers-reduced-motion. Pauzeert bij hover, interactie, verborgen tab en
         zodra het blok minder dan half in beeld staat. */
      var rafId = null;
      var hovering = false;
      var holdUntil = 0;
      var lastTs = 0;
      var pos = 0;
      var loopWidth = 0;
      var AUTO_SPEED = 18;
      var AUTO_HOLD = 6000;
      var originals = Array.prototype.slice.call(track.children);

      /* De kaarten zijn `.reveal`-elementen: ze staan op opacity 0 tot de globale
         reveal-observer ze `.in` geeft. Die observer draait eenmalig bij load en
         ziet alleen wat er dan echt in beeld staat. Kaarten die verderop in de rail
         staan zijn horizontaal weggeclipt en dus nog niet onthuld, en de klonen die
         hieronder ontstaan worden sowieso nooit meer geobserveerd. Resultaat: na een
         halve minuut autoplay schoof er een onzichtbare kaart in beeld - het gat /
         de "missende" kaart. Op dit punt staat het blok al half in beeld, dus alles
         in de rail mag gewoon zichtbaar zijn. */
      function revealAll(el) {
        if (el.classList.contains('reveal')) el.classList.add('in');
        Array.prototype.forEach.call(el.querySelectorAll('.reveal'), function (child) {
          child.classList.add('in');
        });
      }
      function stripReveal(el) {
        if (el.classList.contains('reveal')) { el.classList.remove('reveal'); el.style.transitionDelay = '0s'; }
        Array.prototype.forEach.call(el.querySelectorAll('.reveal'), function (child) {
          child.classList.remove('reveal');
          child.style.transitionDelay = '0s';
        });
      }

      function buildLoop() {
        if (track.dataset.looped === 'true' || originals.length < 2) return;
        if (track.scrollWidth - track.clientWidth <= 4) return;
        originals.forEach(revealAll);
        [1, 2].forEach(function (setIndex) {
          originals.forEach(function (card) {
            var clone = card.cloneNode(true);
            stripReveal(clone);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-clone', setIndex);
            /* Klonen zijn puur decor: haal ze uit de tabvolgorde. */
            Array.prototype.forEach.call(clone.querySelectorAll('a, button'), function (el) {
              el.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          });
        });
        track.dataset.looped = 'true';
      }

      function measureLoop() {
        var firstClone = track.querySelector('[data-clone="1"]');
        loopWidth = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
      }

      /* Middelste set: van edgePad + loopWidth tot edgePad + 2*loopWidth. Zolang de
         rail hierbinnen blijft is er in beide richtingen nog een hele set te gaan. */
      function middleStart() { return edgePad() + loopWidth; }

      function wrap(v) {
        if (loopWidth <= 0) return v;
        while (v >= loopWidth) v -= loopWidth;
        while (v < 0) v += loopWidth;
        return v;
      }

      /* Onopvallend terugzetten naar de middelste set zodra de rail buiten de veilige
         zone komt. Dit gebeurt meteen bij elk scroll-event, niet pas na een stilte-
         debounce: bij momentum-scroll tegen het fysieke einde blijven iOS/Android
         scroll-events afvuren zonder dat scrollLeft nog verandert, waardoor een
         debounce z'n rustmoment nooit kreeg en de rail letterlijk vast bleef zitten
         bij de laatste kaart. Er staat nog een volle set (loopWidth) marge tussen de
         drempel en het echte einde, dus de sprong komt ruim op tijd en is - net als
         bij de auto-play hierboven - onzichtbaar omdat het exact hetzelfde beeld is. */
      function reseat() {
        if (loopWidth <= 0) return;
        var rel = track.scrollLeft - edgePad();
        if (rel < 0 || rel >= 2 * loopWidth) {
          track.scrollLeft = middleStart() + wrap(rel);
          pos = track.scrollLeft;
        }
      }

      function autoFrame(ts) {
        rafId = requestAnimationFrame(autoFrame);
        var dt = lastTs ? Math.min(100, ts - lastTs) : 0;
        lastTs = ts;

        /* Re-sync na een veeg of een pijlklik die de track onder ons verschoof. */
        if (Math.abs(track.scrollLeft - pos) > 1.5) pos = track.scrollLeft;
        if (!dt || hovering || document.hidden || Date.now() < holdUntil) return;
        if (loopWidth <= 0) return;

        pos += AUTO_SPEED * dt / 1000;
        track.scrollLeft = pos;
        if (pos - edgePad() >= 2 * loopWidth) reseat();
      }
      function autoPlay() {
        if (rafId) return;
        buildLoop();
        measureLoop();
        seatRail();
        lastTs = 0;
        pos = track.scrollLeft;
        rafId = requestAnimationFrame(autoFrame);
      }
      function autoStop() { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }
      /* Terug naar de eerste review zodra het blok volledig weg is, zodat je bij een
         tweede bezoek niet midden in de reeks binnenkomt. Gebeurt buiten beeld. */
      function autoRewind() {
        seatRail();
        pos = track.scrollLeft;
      }
      function autoHold() { holdUntil = Date.now() + AUTO_HOLD; }

      slider.addEventListener('mouseenter', function () { hovering = true; });
      slider.addEventListener('mouseleave', function () { hovering = false; });
      slider.addEventListener('focusin', autoHold);
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
        slider.addEventListener(evt, autoHold, { passive: true });
      });
      track.addEventListener('scroll', reseat, { passive: true });
      window.addEventListener('resize', measureLoop);

      if ('IntersectionObserver' in window) {
        var autoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            /* Op intersectionRatio toetsen, niet op isIntersecting: die is al true
               bij een enkele zichtbare pixel, ongeacht de thresholds - daardoor liep
               de rail toch weer leeg terwijl het blok nog onderaan stond te piepen. */
            if (entry.intersectionRatio >= 0.5) { autoPlay(); return; }
            autoStop();
            if (entry.intersectionRatio === 0) autoRewind();
          });
        }, { threshold: [0, 0.5] });
        autoIo.observe(slider);
      } else {
        autoPlay();
      }

      /* Bewust GEEN wheel-handler die verticale scroll onderschept en met
         window.scrollBy doorzet: dat vervangt de native momentum-scroll door een
         kale pixel-voor-pixel sprong, en dan kruipt de pagina zodra je met de
         cursor over een review staat. De rail is verticaal niet scrollbaar
         (overflow-y: hidden) en touch-action: pan-x laat verticaal vegen door,
         dus verticale scroll gaat vanzelf naar de pagina. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordal-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyCta(root) {
      if (!root || root.dataset.stickyCtaInit === 'true') return;
      root.dataset.stickyCtaInit = 'true';

      var after = parseInt(root.getAttribute('data-show-after'), 10);
      if (isNaN(after) || after < 0) after = Math.round(window.innerHeight * 0.95);
      var dismissed = false;

      function syncBarHeight() {
        document.documentElement.style.setProperty('--sticky-cta-h', ((visible && !dismissed) ? root.offsetHeight : 0) + 'px');
      }

      var closeBtn = root.querySelector('[data-sticky-cta-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dismissed = true;
          root.classList.add('is-dismissed');
          root.classList.remove('is-show');
          root.setAttribute('aria-hidden', 'true');
          syncBarHeight();
        });
      }

      var visible = false;
      function reveal() {
        if (visible) return;
        visible = true;
        root.hidden = false;
        root.classList.remove('is-dismissed');
        root.classList.add('is-show');
        root.setAttribute('aria-hidden', 'false');
        syncBarHeight();
      }
      function hide() {
        if (!visible) return;
        visible = false;
        root.classList.remove('is-show');
        root.setAttribute('aria-hidden', 'true');
        syncBarHeight();
      }

      /* Zolang er een echte "in mandje"-knop in beeld staat, heeft de sticky balk geen
         functie en dekt hij alleen maar inhoud af. We herkennen die knoppen aan het
         patroon in plaats van aan klassenamen (.pdp-add / .nordal-pcard__add), zodat
         nieuwe varianten vanzelf meetellen. */
      var ATC_SELECTOR = 'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]';
      var atcInView = 0;
      var atcSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
      var atcObserver = null;

      if ('IntersectionObserver' in window) {
        atcObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var was = entry.target.dataset.stickyCtaSeen === 'true';
            if (entry.isIntersecting === was) return;
            entry.target.dataset.stickyCtaSeen = entry.isIntersecting ? 'true' : 'false';
            atcInView += entry.isIntersecting ? 1 : -1;
            if (atcInView < 0) atcInView = 0;
          });
          apply();
        }, { threshold: 0.5 });
      }

      function watchAtcButtons() {
        if (!atcObserver) return;
        document.querySelectorAll(ATC_SELECTOR).forEach(function (btn) {
          if (btn.closest('[data-sticky-cta]')) return;
          if (atcSeen) {
            if (atcSeen.has(btn)) return;
            atcSeen.add(btn);
          } else if (btn.dataset.stickyCtaWatched === 'true') {
            return;
          }
          btn.dataset.stickyCtaWatched = 'true';
          atcObserver.observe(btn);
        });
      }

      /* Zelfde idee voor knoppen die naar dezelfde bestemming leiden als de balk zelf
         ("Ontdek de collectie"): staat
         zo'n knop al in beeld, dan voegt de balk niets toe. Secties zetten
         data-sticky-cta-competitor op die specifieke knoppen. */
      var competitorInView = 0;
      var competitorSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
      var competitorObserver = null;

      if ('IntersectionObserver' in window) {
        competitorObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var was = entry.target.dataset.stickyCtaCompetitorSeen === 'true';
            if (entry.isIntersecting === was) return;
            entry.target.dataset.stickyCtaCompetitorSeen = entry.isIntersecting ? 'true' : 'false';
            competitorInView += entry.isIntersecting ? 1 : -1;
            if (competitorInView < 0) competitorInView = 0;
          });
          apply();
        }, { threshold: 0.5 });
      }

      function watchCompetitorButtons() {
        if (!competitorObserver) return;
        document.querySelectorAll('[data-sticky-cta-competitor]').forEach(function (btn) {
          if (btn.closest('[data-sticky-cta]')) return;
          if (competitorSeen) {
            if (competitorSeen.has(btn)) return;
            competitorSeen.add(btn);
          } else if (btn.dataset.stickyCtaCompetitorWatched === 'true') {
            return;
          }
          btn.dataset.stickyCtaCompetitorWatched = 'true';
          competitorObserver.observe(btn);
        });
      }

      /* Toont meteen bij laden op desktop. Op mobiel oogt dat te druk boven op de
         eerste hero-slide, dus daar pas zodra je volledig voorbij de fold (het eerste
         schermvullende beeld) bent gescrold - vandaar window.innerHeight in plaats
         van een vaste pixelwaarde, zodat het meeschaalt met het toestel. */
      var MOBILE_QUERY = '(max-width: 760px)';
      function isMobile() {
        return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
      }

      function apply() {
        if (dismissed) return;
        if (atcInView > 0 || competitorInView > 0) {
          hide();
        } else if (isMobile() && window.scrollY < window.innerHeight) {
          hide();
        } else {
          reveal();
        }
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          apply();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', syncBarHeight, { passive: true });
      document.addEventListener('shopify:section:load', watchAtcButtons);
      document.addEventListener('shopify:section:load', watchCompetitorButtons);
      watchAtcButtons();
      watchCompetitorButtons();
      onScroll();
      syncBarHeight();
    }

    function boot() {
      document.querySelectorAll('[data-sticky-cta]').forEach(initStickyCta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-sticky-cta]');
      if (el) initStickyCta(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
